module.exports = __webpack_public_path__ + "img/pdos.ab442100.jpg";